import React from 'react';

import { humanizeKey } from '../../util/listingHelpers';

import ExpandableSection from './ExpandableSection';
import css from './ListingPage.module.css';

const SectionSpecsMaybe = props => {
  const { specs, intl, excludeKeys } = props;

  if (!specs || typeof specs !== 'object') return null;

  // When the listing is part of a product group, the DYNAMIC specs (the ones that vary
  // across the group) are shown in the variants table instead — so this block shows only
  // the STABLE specs common to every variant. excludeKeys = the group's axis keys.
  const exclude = new Set((excludeKeys || []).map(k => String(k).toLowerCase()));
  const entries = Object.entries(specs).filter(
    ([k, v]) => v != null && String(v).trim() !== '' && !exclude.has(String(k).toLowerCase())
  );
  if (entries.length === 0) return null;

  return (
    <ExpandableSection
      className={css.sectionMargins}
      title={intl.formatMessage({ id: 'ListingPage.specsTitle' })}
    >
      <table className={css.specsTable}>
        <tbody>
          {entries.map(([key, value]) => (
            <tr key={key} className={css.specsRow}>
              <td className={css.specsKey}>{humanizeKey(key)}</td>
              <td className={css.specsValue}>{String(value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </ExpandableSection>
  );
};

export default SectionSpecsMaybe;
